import React from "react";

import MultipleSelectionAttributeCard from "./Components/MultipleSelectionAttributeCard";

import { type AppUserSession } from "@/schemas/auth/session";
import {
  Language,
  UserLanguageAttributeSet,
} from "@/schemas/profile/attributes/UserLanguageAttributeSet";
import type { AttributeValue } from "@/schemas/attribute/AttributeSet";

type LanguageProps = {
  session: AppUserSession;
  values: Language[];
};

function LanguageSelection({
  session,
  values,
}: LanguageProps): React.JSX.Element {
  const items = values.map((l) => UserLanguageAttributeSet.map[l]);
  const typedValues = items.filter(
    (item): item is AttributeValue => item !== undefined,
  );

  return (
    <MultipleSelectionAttributeCard
      session={session}
      title={"Languages"}
      icon={"language"}
      attribute={UserLanguageAttributeSet}
      values={typedValues}
    />
  );
}

export default LanguageSelection;
